import axios from "@/utils/axios.js";

/**
 * Получение списка контрактов
 */
function getСontracts(perPage, currentPage, sort, search) {
    return new Promise((resolve, reject) => {
        axios
            .get(`contract?&sort=${sort}${search ? `&search[All]=${search}` : ''}&per-page=${perPage}&page=${currentPage}`)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * Получение контракта
 */
function getContract(id) {
    return new Promise((resolve, reject) => {
        axios
            .get(`contract/${id}`)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * Создание контракта
 * @param {String} name
 * @param {String} contract_at
 */
function createContract(
    name,
    contract_at
) {
    const contractData = {
        name,
        contract_at
    };

    return new Promise((resolve, reject) => {
        axios
            .post("contract", contractData)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * Удаление контрактов
 */
function deleteContracts(ids) {
    return new Promise((resolve, reject) => {
        axios
            .delete(`contract`, { data: { contracts: ids } })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * Восстановление контракта
 */
function restoreContract(id) {
    return new Promise((resolve, reject) => {
        axios
            .post(`contract/${id}/restore`)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * Редактирование контракта
 * @param {Number} id
 * @param {String} name
 * @param {String} contract_at
 */
function updateContract(
    id,
    name,
    contract_at
) {
    const contractData = {
        name,
        contract_at
    };

    return new Promise((resolve, reject) => {
        axios
            .put(`contract/${id}`, contractData)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export {
    getСontracts,
    getContract,
    createContract,
    deleteContracts,
    restoreContract,
    updateContract,
}